import { styled } from '@styles';
import { Accordion, Card } from 'react-bootstrap';

export const FaqTopicAccordionToggle = styled(Accordion.Toggle)`
  background-color: #f2f3f5;
  color: black;

  &:first-child {
    border-bottom: 0;
  }
`;

export const FaqTopicCardHeader = styled(Card.Header)`
  background-color: #f2f3f5;
  border-color: #f2f3f5;
  color: black;
`;
